import { useMemo } from 'react'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useLocalStorage } from 'hooks/useLocalStorage'

export const useInitialRoute = () => {
  const { meta } = useCurrentUser()

  const [initialRoute, setInitialRoute] = useLocalStorage(
    'initialRoute',
    !meta.loggedIn ? window.location.pathname : '',
    true,
  )

  const memoizedInitialRoute = useMemo(() => initialRoute ?? '', [initialRoute])

  return {
    initialRoute: memoizedInitialRoute,
    setInitialRoute,
  }
}
